import { Hyperlink } from '@nokia-csf-uxr/ccfk';
import { AccountContext } from '../contexts/AccountContext';
import React from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';
import NewsModal from './NewsModal';
import { Link } from 'react-router-dom';
import { CONFIG } from '../config';

/**
 * Header of the application
 */
// #547 Fix Information severity issues
/*
<Hyperlink className='position-relative' id="hyperlink" href="mailto:wld.support@nokia.com?subject=Wavence Link Designer user feedback" style={{top: "1px", marginRight: ".75rem", fontSize: "unset"}}>Send feedback to Nokia</Hyperlink>
*/
export default class HeaderWLD extends React.Component<{},any> {

 // #547 Fix Information severity issues
    /**
     * Send feedback 
     */
    sendFeedback = () => {
      window.open('mailto:'+CONFIG.requestAccessEmail+'?subject=Wavence Link Designer user feedback');
  }

  render() {
    return (
      <Navbar bg="light" expand="lg" className='shadow-sm bg-white'>
        <Container>
          <Navbar.Brand>
            <Image src="/assets/logo/nokia_logo.svg" width={125} height={45} fluid />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">                
                <Navbar.Text>
                  <div><h4 className="h4 ps-4 pt-2">Wavence Link Designer</h4></div>
                </Navbar.Text>                
              </Nav>
              <Navbar.Text>
                <div>
                  <button type="button" className="btn position-relative p-0" data-bs-toggle="modal" data-bs-target="#news-modal" style={{marginRight: ".75rem"}}>
                    See news
                    <span className="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle">
                      <span className="visually-hidden">New update</span>
                    </span>
                  </button>
                </div>
              </Navbar.Text>
              <Navbar.Text>                
                <Hyperlink className='position-relative' id="hyperlink"  href="#" rel="nofollow"  onClick={() => this.sendFeedback()} style={{top: "1px", marginRight: ".75rem", fontSize: "unset"}}>Send feedback to Nokia</Hyperlink>
              </Navbar.Text>
              <Navbar.Text>
                  <AccountContext.Consumer>
                    {v => (
                        <>
                        <div>
                        { v.displayName }
                        </div>
                        <NewsModal accessToken={v.token} />
                        </>
                    )}
                </AccountContext.Consumer> 
              </Navbar.Text>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  }
}